import { ref } from 'vue';
import {
  countryCodeIsMexico,
  peekCachedCurrentIpCountryCode,
  resolveCountryCodeFromCurrentIp,
} from '@/utils/ip-country-lookup';

/**
 * 落地 CoDi / SPEI 仅当前出口 IP 为 MX 时展示。
 * 资料国家码不参与；探测失败 fail-closed（不展示）。
 */
export const MEXICO_PAY_IP_GUARD_ENABLED = true;

export const mexicoPayIpAllowed = ref(
  !MEXICO_PAY_IP_GUARD_ENABLED || countryCodeIsMexico(peekCachedCurrentIpCountryCode())
);

export function resetMexicoPayIpAllowed() {
  mexicoPayIpAllowed.value = !MEXICO_PAY_IP_GUARD_ENABLED;
}

/**
 * 仅看当前出口网络。打开弹窗时跟在美国 IP 探测之后调用即可复用缓存。
 * @param {{ forceRefresh?: boolean }} [options]
 * @returns {Promise<boolean>}
 */
export async function resolveIsMexicoPayIpAllowed({ forceRefresh = false } = {}) {
  if (!MEXICO_PAY_IP_GUARD_ENABLED) {
    mexicoPayIpAllowed.value = true;
    return true;
  }
  const countryCode = await resolveCountryCodeFromCurrentIp({ forceRefresh }).catch(() => null);
  const allowed = countryCodeIsMexico(countryCode);
  mexicoPayIpAllowed.value = allowed;
  return allowed;
}
